import React, {ReactNode} from "react";

interface CardProps {
    children: ReactNode;
  }

const CardWrapper: React.FC<CardProps> = ({ children }) => {
    return (
      <div className=" mx-5 my-2 bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="px-6 py-4">
          {children}
        </div>
      </div>
    );
  };

export default CardWrapper;